var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddWorkBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.173,
    height: 19.579,
    viewBox: "0 0 25.173 19.579",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-book-open",
    "data-name": "Icon awesome-book-open",
    d: "M23.7,2.252c-2.395.136-7.155.631-10.094,2.429a.672.672,0,0,0-.318.576v15.9a.692.692,0,0,0,1.017.59c3.023-1.522,7.4-1.937,9.558-2.051a1.363,1.363,0,0,0,1.312-1.34V3.594A1.37,1.37,0,0,0,23.7,2.252ZM11.57,4.682c-2.938-1.8-7.7-2.293-10.093-2.429A1.371,1.371,0,0,0,0,3.594V18.359A1.362,1.362,0,0,0,1.312,19.7c2.163.114,6.538.529,9.561,2.052a.69.69,0,0,0,1.014-.588V5.249A.658.658,0,0,0,11.57,4.682Z",
    transform: "translate(0 -2.25)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddWorkBook);
export default __webpack_public_path__ + "static/media/addWorkBook.1cc49ae90feb52360b8b39ff306e590d.svg";
export { ForwardRef as ReactComponent };